var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNullify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2D4452"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M232,328H10.336c5.78,19.764,13.892,38.528,24,56H232c8.8,0,16-7.2,16-16v-24 C248,335.2,240.8,328,232,328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8762E"
    },
    d: "M324.436,298.692l-79.196,79.2c-6.224,6.22-16.404,6.22-22.624,0l-90.508-90.512 c-6.228-6.224-6.228-16.404,0-22.628l79.196-79.192L324.436,298.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D96F2A"
    },
    d: "M313.128,287.38l-79.2,79.2c-6.224,6.224-16.408,6.224-22.624,0l11.312,11.312 c6.228,6.22,16.408,6.22,22.624,0l79.196-79.2L313.128,287.38z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.25,
    y: 197.728,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 242.0398 -136.8803)",
    style: {
      fill: "#E6E6E6"
    },
    width: 159.998,
    height: 52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.558,
    y: 210.433,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 237.3655 -148.1847)",
    style: {
      fill: "#B3B3B3"
    },
    width: 159.998,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.761,
    y: 172.253,
    transform: "matrix(0.7072 -0.7071 0.7071 0.7072 -53.8733 218.4314)",
    style: {
      fill: "#B3B3B3"
    },
    width: 19.997,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.891,
    y: 186.347,
    transform: "matrix(0.7071 -0.7072 0.7072 0.7071 -59.6937 232.5949)",
    style: {
      fill: "#B3B3B3"
    },
    width: 20.001,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.073,
    y: 200.51,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -65.5645 246.7023)",
    style: {
      fill: "#B3B3B3"
    },
    width: 20,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.209,
    y: 214.624,
    transform: "matrix(0.7071 -0.7072 0.7072 0.7071 -71.3946 260.9037)",
    style: {
      fill: "#B3B3B3"
    },
    width: 20.001,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.366,
    y: 228.77,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -77.2605 274.9796)",
    style: {
      fill: "#B3B3B3"
    },
    width: 20,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.431,
    y: 242.956,
    transform: "matrix(0.7071 -0.7072 0.7072 0.7071 -83.1632 289.158)",
    style: {
      fill: "#B3B3B3"
    },
    width: 19.993,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.619,
    y: 257.062,
    transform: "matrix(0.707 -0.7072 0.7072 0.707 -88.9784 303.3547)",
    style: {
      fill: "#B3B3B3"
    },
    width: 20,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.799,
    y: 271.191,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -94.8217 317.4612)",
    style: {
      fill: "#B3B3B3"
    },
    width: 20,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.913,
    y: 233.079,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 246.7458 -125.5394)",
    style: {
      fill: "#B3B3B3"
    },
    width: 159.998,
    height: 4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 186.463,
    y: 241.556,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 250.265 -117.0812)",
    style: {
      opacity: 0.6,
      fill: "#994E1E",
      enableBackground: "new"
    },
    width: 159.998,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E65445"
    },
    d: "M279.188,179.9L408.616,50.472c-12.08-8.98-24.988-16.884-38.572-23.656L248.072,148.792 L279.188,179.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC4B3D"
    },
    d: "M408.616,50.468L279.188,179.896l50.916,50.912L459.8,101.116 C445.192,81.932,427.968,64.86,408.616,50.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B34136"
    },
    d: "M459.792,101.116l-129.7,129.696l31.112,31.108l122.62-122.616 C476.92,125.844,468.892,113.064,459.792,101.116z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.072,
    y: 201.967,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 233.8728 -156.6842)",
    style: {
      opacity: 0.6,
      fill: "#994E1E",
      enableBackground: "new"
    },
    width: 159.998,
    height: 4
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNullify);
export default __webpack_public_path__ + "static/media/nullify.6cceda1a75a765244cc28bd13c9d4fdf.svg";
export { ForwardRef as ReactComponent };